import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Tag from "../../../../fragments/Tag";
import { isPrimaryInsurance } from "../../../../../lib/primaryItemScripts";
import { frontendOptions } from "../../../../../lib/systemData";


export default function CaseDetailsInsuranceTagItem({item}) {
    const activeCase = useSelector(state => state.case.activeCase)
    const [specificItem, setSpecificItem] = useState(item)

    useEffect(() => {
        if (specificItem && activeCase && activeCase.case) {
            if (activeCase.case[specificItem.label]) { // set tag to true if its true on the case (global items)
                setSpecificItem({
                    ...specificItem,
                    active: true
                })
            } else {
                setSpecificItem({
                    ...specificItem,
                    active: false
                })
            }

            let primary =  isPrimaryInsurance(activeCase, 'liabilities')

            if (specificItem.label_on_item == 'commercial_policy') {
                // if it is comercial policy, check every liability and if any of them is active and has commercial policy, set the tag to true and the color to status color
                // if there is one liability with status assumed, set the tag to true and the color to green

                let activeLiabilities = activeCase.liabilities.filter(item => item.active && item.commercial_policy)
      
                if (activeLiabilities.length > 0) {
                    let findAsumedLiability = activeLiabilities.find(item => item.liability_status == 1)
                    if (findAsumedLiability) {
                        let object = {
                            ...specificItem,
                            active: true,
                            color: 'Green'
                        }
                        setSpecificItem(object)
                    }
                    else {
                        let object = {
                            ...specificItem,
                            active: true,
                            color: frontendOptions()?.assumedOptions.find(item => item.value == activeLiabilities[0].liability_status)?.color
                        }
                        setSpecificItem(object)
                    }
                } else {
                    if (activeCase.case[specificItem.label]) { // set tag to true if its true on the case (global items)
                        setSpecificItem({
                            ...specificItem,
                            active: true,
                            color: 'Grey'
                        })
                    } else {
                        setSpecificItem({
                            ...specificItem,
                            active: false
                        })
                    }
                }
                // let activeLiabilities = activeCase.liabilities.filter(item => item.active && item.commercial_policy)
                // if (activeLiabilities.length > 0) {
                //     let object = {
                //         ...specificItem,
                //         active: true,
                //         color: activeLiabilities[0].liability_status ? frontendOptions()?.assumedOptions.find(item => item.value == activeLiabilities[0].liability_status)?.color : 'Yellow'
                //     }
                //     setSpecificItem(object)
                // }
            } else {
                if (primary && primary[specificItem.label_on_item]) {
                    let object = { //set tag to true if it is on the primary insurance and add the color of the liability status
                        ...specificItem,
                        active: true,
                        color: primary.liability_status ? frontendOptions()?.assumedOptions.find(item => item.value == primary.liability_status)?.color : 'Yellow'
                    }
    
                    if (specificItem.label_on_item == 'hit_run') { // for hit and run the color is allways red until the status is assumed!!!
                        object.color =  primary.liability_status == 1 ? "Green" : 'Red'
                    }
    
                    setSpecificItem(object)
                } else { //there is no primary (it should not be posiible) or the item is not selected on primary and need to find it on the rest.
    
                    let findAnotherItem = activeCase.liabilities.find(item => (item.active && item[specificItem.label_on_item]))
                    if (findAnotherItem) {
                        let object = { //set tag to true if it is on the primary insurance and add the color of the liability status
                            ...specificItem,
                            active: true,
                            color: findAnotherItem.liability_status ? frontendOptions()?.assumedOptions.find(item => item.value == findAnotherItem.liability_status)?.color : 'Yellow'
                        }
                        if (specificItem.label_on_item == 'hit_run') { // for hit and run the color is allways red until the status is assumed!!!
                            object.color =  findAnotherItem.liability_status == 1 ? "Green" : 'Red'
                        }
                        setSpecificItem(object)
                    } else {
                        let object = {
                            ...specificItem,
                            active: activeCase.case[specificItem.label],
                            color: 'Grey',
                        }
                        if (specificItem.label_on_item == 'hit_run') { // for hit and run the color is allways red until the status is assumed!!!
                            object.color = 'Red'
                        }
                        setSpecificItem(object)
    
                        
                    }
                    
                }
            }

            
        }
    }, [activeCase])   

    return <>
        {specificItem.active ? <Tag color={specificItem.color}>{specificItem.name}</Tag> : ''}
    </>
}